import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar-search',
  templateUrl: './navbar-search.component.html',
  styleUrls: ['./navbar-search.component.scss'],
  standalone: false
})
export class NavbarSearchComponent {
  constructor() { }
}
